var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { MenuItem, TextField } from '@material-ui/core';
import React from 'react';
import { useSiteContext } from '../..';
import { useFindNearestRouteComponent } from '../../hooks/site-route/useFindNearestRouteComponent';
const SiteRouteParamPicker = (_a) => {
    var _b, _c;
    var { value, onChange } = _a, props = __rest(_a, ["value", "onChange"]);
    const { configureComponent } = useSiteContext();
    const routeComponent = useFindNearestRouteComponent(configureComponent);
    const additionalInputProps = {};
    if (!props.variant)
        additionalInputProps.disableUnderline = true;
    const options = ((_c = (_b = routeComponent === null || routeComponent === void 0 ? void 0 : routeComponent.props) === null || _b === void 0 ? void 0 : _b.path) === null || _c === void 0 ? void 0 : _c.split('/').filter(part => part[0] === ':').map(part => part.slice(1))) || [];
    return (React.createElement(TextField, Object.assign({ select: true, fullWidth: true, size: 'small', label: 'Select Route Param', value: value || 'Select Route Param' }, props, { InputProps: Object.assign({}, additionalInputProps), onChange: event => {
            onChange === null || onChange === void 0 ? void 0 : onChange(event.target.value);
        } }),
        React.createElement(MenuItem, { disabled: true, value: 'Select Route Param' }, "Select Route Param"),
        options.map(option => (React.createElement(MenuItem, { key: option, value: option }, option)))));
};
export default SiteRouteParamPicker;
//# sourceMappingURL=SiteRouteParamPicker.js.map